
export default {
  props: {
    waybillNo: {
      type: String,
    },
    cusId: {
      type: String,
    },
    mobile: {
      type: String,
      default: '',
    },
    // 区号
    curPhoneCode: {
      type: String,
      default: '',
    },
    // 验证码
    validateCode: {
      type: String,
      default: '',
    },
  },
  computed: {
    customerType() {
      return this.$route.query.customer_type || ''
    },
    channel() {
      return this.customerType === 'samsung' ? 2 : 3
    },
  },
  data() {
    // let validate = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('Please input the password again'));
    //   } else if (value !== this.ruleForm.pass) {
    //     callback(new Error("Two inputs don't match!"));
    //   } else {
    //     callback();
    //   }
    // };
    // 异步校验函数返回 Promise
    let asyncValidator = (rule, val, callback) => {
      if (!val) {
        callback(
          new Error(
            this.$t('serviceSupport.querySupport.waybills.pleaseEnter') +
              this.$t('serviceSupport.querySupport.waybills.contactWay')
          )
        )
      } else {
        this.checkPhone((res) => {
          if (!res) {
            callback(
              new Error(
                this.$t(
                  'serviceSupport.clearanceService.certificateQuery.mobileTip'
                )
              )
            )
          } else {
            callback()
          }
        })
      }
    }
    return {
      butType: true,
      showCancelReservation: false,
      mobileAreaCodeList: [],
      form: {
        addresseeNationalPhoneCode: '',
      },
      oldData: {},
      addresseePostalCodeList: [],
      // countryCode: 'CN',
      rules: {
        addresseeContName: [
          {
            required: true,
            message:
              this.$t('serviceSupport.querySupport.waybills.pleaseEnter') +
              this.$t('serviceSupport.querySupport.waybills.addresseeContName'),
            trigger: 'blur',
          },
        ],
        receiverPhoneNumber: [
          // { required: true, message: '111' , trigger: 'blur' },
          // { required: true, message: this.$t('serviceSupport.querySupport.waybills.pleaseEnter') + this.$t('serviceSupport.querySupport.waybills.contactWay'), trigger: 'blur' },
          // { validator: validate, trigger: 'blur' },
          {
            required: true,
            validator: asyncValidator,
            trigger: 'change',
          },
        ],
        addresseePostalCode: [
          {
            required: true,
            message:
              this.$t('serviceSupport.querySupport.waybills.pleaseEnter') +
              this.$t('serviceSupport.querySupport.waybills.postcode'),
            trigger: 'blur',
          },
        ],
        receiverAddress: [
          {
            required: true,
            message:
              this.$t('serviceSupport.querySupport.waybills.pleaseEnter') +
              this.$t('serviceSupport.querySupport.waybills.detailedAddress'),
            trigger: 'blur',
          },
        ],
      },
      receiverAddress: '',
      countryList: [],
      countryModel: '',
      cancelVisible: false,
      withdrawVisible: false,
      timer: null, // 添加定时器引用
    }
  },
  mounted() {
    // this.init()
    this.countries()
    // this.queryLivePostCodeList();
  },
  beforeDestroy() {
    if(this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 获取国家
    async countries() {
      const res = await this.$API.support.getCountries()
      this.countryList = res.map((item) => {
        return {
          label: item.countryNameI18n,
          value: item.countryCode,
        }
      }) ?? []
      this.countryModel = this.countryList?.length ? this.countryList[0].value : ''
      // 只有一个国家的时候 默认
      // if ( this.countryList.length == 1 ){

      // }
      this.queryReceiverInfo()
      this.fetchMobileAreaCodeList()
    },
    //  获取邮编下拉框
    async queryLivePostCodeList(val) {
      if (val.length > 2) {
        const res = await this.$API.common.queryBoundLivePostCode({
          countryCode: this.countryModel,
          postCode: val,
        })
        if (res?.length > 0) {
          // const isShowCountry =
          //   item.countryCode?.toUpperCase() === 'CN' ? false : true
          res.forEach((i) => {
            const region1 = i.region1Name || i.region2
            const region2 = i.region2Name || i.region1
            const region3 = i.region3Name || i.region3
            const obj = {
              detailShowNameLong: [region1, region2, region3],
            }
            // obj.detailShowNameLong = !isShowCountry
            //   ? [...obj.detailShowNameLong]
            //   : [item.countryName, ...obj.detailShowNameLong]
            obj.detailShowNameLong = obj.detailShowNameLong
              .filter((i) => i)
              .join('-')
            // Object.assign(i, { countryName: item.countryName }, obj)
            Object.assign(i, obj)
          })
          this.addresseePostalCodeList = res?.length ? res : []
          console.log('addresseePostalCodeList', this.addresseePostalCodeList)
        } else {
          this.addresseePostalCodeList = []
        }
      }
    },
    handleDestPostChange(id) {
      if (id) {
        let data = this.addresseePostalCodeList.filter((item) => {
          return item.id == id
        })
        //  this.receiverAddress = data[0].detailShowNameLong
        if(data && data?.length){
          this.getQueryProvinceCityByPostCodeApi(data[0].postCode)
        }
      }
    },
    async getQueryProvinceCityByPostCodeApi(postCode) {
      let params = {
        countryCode: this.countryModel,
        // postCode: data[0].postCode
        postCode: postCode,
      }
      const res = await this.$API.support.queryProvinceCityByPostCodeApi(params)
      if (res && res?.length && res[0]) {
        console.log('queryProvinceCityByPostCodeApi---返回', res[0])
        this.receiverAddress =
          res[0].region1Name +
          '-' +
          res[0].region2Name +
          '-' +
          res[0].region3Name

        this.form.newReceiverCity = res[0].region2Name // 城市名称
        this.form.newReceiverCityCode = res[0].cityCode // 城市编码
        this.form.newReceiverProvince = res[0].region1Name // 收件方省名称
        this.form.newReceiverProvince = res[0].region1Name // 收件方省名称
        this.form.postcode = res[0].postCode // 新收件人邮编
      }
    },
    handleSearch(value) {
      if (value.length > 2) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.queryLivePostCodeList(value?.trim())
        }, 300)
      }
    },
    // 获取手机区号列表
    async fetchMobileAreaCodeList() {
      try {
        const res = await this.$API.support.getCustomsDeclareCountryListApi()

        this.mobileAreaCodeList = res.map((item) => {
          return {
            countryCode: item.countryCode,
            countryName: item.countryName,
            countryNameI18n: item.countryNameI18n,
            phoneCode: item.phoneCode,
            value: `${item.countryCode}`,
            label: `${item.countryNameI18n} +${item.phoneCode}`,
          }
        })
        console.log('mobileAreaCodeList--', this.mobileAreaCodeList)
        // 默认展示当前站点手机区号
        const matchedItem = this.mobileAreaCodeList?.find(
          (i) => i.countryCode === this.site.toUpperCase()
        )
        this.form.addresseeNationalPhoneCode = matchedItem?.countryCode || 'CN'
      } catch (e) {
        console.log(e)
      }
    },
    // 过滤
    filterOption(input, option) {
      const key = option?.data?.key || ""
      return key.toLowerCase()?.includes((input || '').toLowerCase())
    },
    previousPage() {
      this.$emit('previousPage')
    },
    handleOk() {
      this.showCancelReservation = false
    },
    handleCancel() {
      this.showCancelReservation = false
    },
    async queryReceiverInfo() {
      const params = {
        serviceCodes: '5,7', // 验证时只存在5,7同时存在的情况
        waybillNo: this.waybillNo,
        phoneCode: this.curPhoneCode, // 区号
        phoneNumber: this.mobile, // 手机号
        businessType: '3', // 业务场景  1: 通关证明文件查询 2: 发票申请 3: 预约派送日期/自取
        sendType: '1', // 发送场景  1: 短信  2: 邮箱
        validateCode: this.validateCode, // 验证码
        channel: this.channel,
      }
      if (this.channel === 2) {
        params.customerType = this.customerType
      }
      const res = await this.$API.support.queryReceiverInfo(params)
      this.oldData = res
      this.form = {
        addresseeContName: res.addresseeContName, // 名称
        // addresseeNationalPhoneCode:  res.addresseeNationalPhoneCode, // 区号
        addresseeNationalPhoneCode: res.countryCode, // 区号
        receiverPhoneNumber: res.addresseeMobile, // 手机号
        extensionNo: res.extensionNo, // 分机号
        addresseePostalCode: res.addresseePostalCode, // 邮编
        receiverAddress: res.receiverAddr, // 详情地址
      }
      this.getQueryProvinceCityByPostCodeApi(res.addresseePostalCode)
    },
    // 列表清空
    resetForm() {
      this.form.addresseeNationalPhoneCode = ''
      this.form.extensionNo = ''
      this.receiverAddress = ''
      this.$refs.ruleForm.resetFields()
    },
    async submitDirective() {
      console.log('mobile', this.mobile)
      if (!this.form.addresseeNationalPhoneCode) {
        this.$message.warn(
          this.$t('serviceSupport.querySupport.waybills.pleaseSelect') +
            this.$t('serviceSupport.querySupport.waybills.areaCode')
        )
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log('submit!', this.form)
          console.log('mobileAreaCodeList', this.mobileAreaCodeList)
          let phoneCode = this.mobileAreaCodeList.filter(
            (item) => item.value === this.form.addresseeNationalPhoneCode
          )[0].phoneCode
          let params = {
            ...this.form,
            name: this.form.addresseeContName,
            postcode: this.form.addresseePostalCode,
            phoneCode: phoneCode,
            waybillNo: this.waybillNo,
            // addresseeCountryCode: this.countryCode,
            addresseeCountryCode: this.countryModel, // 国家
            verifiedPhoneNumber: this.mobile,
            channel: this.channel,
          }
          if (this.channel === 2) {
            params.customerType = this.customerType
          }
          this.$API.support.submitDirective(params).then((res) => {
            if (res.success) {
              this.cusId = res.cusId
              this.$message.success(
                this.$t(
                  'serviceSupport.querySupport.waybills.submitSuccessfully'
                )
              )
              // this.showProcess=false
              this.butType = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 取消申请
    async cancelApplyFor() {
      const params = {
        cusId: this.cusId,
        waybillNo: this.waybillNo,
        phoneCode: this.curPhoneCode, // 区号
        validateCode: this.validateCode, // 验证码
        verifiedPhoneNumber: this.mobile, // 手机号
        channel: this.channel,
      }
      // this.trackFn()
      const res = await this.$API.support.cancelDirectiveApi(params)
      if (res?.success) {
        this.showCancelReservation = false
        this.$message.success(
          this.$t(
            'serviceSupport.querySupport.waybills.successCancelAppointment'
          )
        )
        // 取消后 返回上一页
        this.previousPage()
      } else {
        res?.msg &&
          this.$message.error(
            this.$t(
              'serviceSupport.querySupport.waybills.successCancelAppointment'
            )
          )
      }
    },
    // 手机号校验
    async checkPhone(callback) {
      console.log(
        'this.form.addresseeNationalPhoneCode',
        this.form.addresseeNationalPhoneCode
      )
      let phoneCode = this.mobileAreaCodeList.filter((item) => {
        // let phoneCode = '+' + item.phoneCode
        return this.form.addresseeNationalPhoneCode == item.value
      })
      const params = {
        // countryCode: this.countryModel, // 国家二字码
        // phoneCode: this.form.addresseeNationalPhoneCode, // 区号
        countryCode: phoneCode?.length ? phoneCode[0]?.countryCode : '',
        phoneCode: phoneCode?.length ? phoneCode[0]?.phoneCode : '',
        phoneNumber: this.form.receiverPhoneNumber, // 手机号
      }
      try {
        const res = await this.$API.support.checkPhoneApi(params)
        callback(res)
      } catch (e) {
        console.log(e)
      }
    },
  },
}
